import React, {useEffect, useState} from "react";
import {
    Navigate, 
    Outlet,
    useNavigate,
  } from "react-router-dom";

import "./auth.css";
import { useTranslation } from 'react-i18next';

const config = require('../config');
const host = config.host;
const port = config.port;

export const Login = (props) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleKeyPress = (event) => { 
      if (event.key === 'Enter') { 
        handleLogin(); 
      } 
    };

    const handleLogin = async () => {
      //Here, you would send the phone number and pin to your backend for verification
      if(!phoneNumber || !password){
        alert('Please enter your phone number and password.');
        return;
      }
     
      fetch(`/auth/login`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          {
            phone_no:`${phoneNumber}`,
            password: password
          })
      })
      .then(response => response.json())
      .then(data => {
        if(data.token){
          sessionStorage.setItem('token', data.token);
          sessionStorage.setItem("isLoggedIn", "true"); 
          props.SetIsLoggedIn(true);
          navigate("/home");
        } else{
          alert(data.message)
        }
      })
      .catch(error => {
          console.error('Error:', error);
      });
    }

  

  const { t } = useTranslation();

    return (
      <>
        <div className="first-page-box first-page-top-box">
                <span className="main-title">Ring<br/>Generation</span>
        </div>

      <div className="login-container">

        <div className="login-box bottom-box">
          <span className="login-title">{t("login")}</span>
          <div className="login-line"></div>
          <div className="login-input-group">
            <label htmlFor="phone-number">{t("phone_number")}</label>
            <input
              type="text"
              id="phone-number"
              placeholder={t("phone_no_placeholder")}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="login-input-field"
              onKeyDown={handleKeyPress}
            />
          </div>
          <div className="login-input-group">
            <label htmlFor="password">{t("password")}</label>
            <input
              id="password"
              type="password"
              placeholder={t("password_placeholder")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input-field"
              onKeyDown={handleKeyPress}
            />
          </div>
          <button onClick={handleLogin} className="login-action-button">
            {t("next")}
          </button>
        </div>

    </div>

    </>
      );
}


// request for login status from backend upon rendering
export const PrivateRoute = () => {
  const [login, setLogin] = useState();
  
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    
    fetch(`/auth/verify`, {
      method: 'GET',
      headers: {
          'Authorization': `Bearer ${token}`,
      }
  })
      .then((response) => response.json())
      .then((data) => {
        setLogin(data.verified);
      });
  }, []);


  if (login === undefined) return null; // or loading indicator, etc...

  return login === true ? <Outlet /> : <Navigate to="/" replace />;
};


// need modify
export const AdminOnlyRoute = () => {
	const [admin, setAdmin] = useState();
	// request for login status from backend upon rendering
	useEffect(() => {
    const token = sessionStorage.getItem("token");
	  fetch(`/auth/verify`, {
		method: "GET",
		headers: {
      'Authorization': `Bearer ${token}`,
  }
	  })
		.then((response) => response.json())
		.then((data) => {
		  setAdmin(data.userRole==="admin") // check if role is admin
		});
	}, []);
  

	if (admin === undefined) return null; // or loading indicator, etc...
  
	return admin === true ? <Outlet /> : <Navigate to="/" replace />;
  };
